import { render, staticRenderFns } from "./emptyrectangle.vue?vue&type=template&id=7744fea1"
import script from "./emptyrectangle.vue?vue&type=script&lang=js"
export * from "./emptyrectangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports